var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.editClient)?_c('client-details',{attrs:{"client":_vm.client,"loading":_vm.loading},on:{"editCard":_vm.clientEdit}}):_c('client-edit',{attrs:{"client":_vm.client},on:{"editCard":_vm.clientEdit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }